export const showOption = (locale) => [
  {
    label: locale === "id" ? "Semua" : "All",
    value: "",
  },
  {
    label: 10,
    value: 10,
  },
  {
    label: 20,
    value: 20,
  },
  {
    label: 50,
    value: 50,
  },
]

export const sortOption = (locale) => [
  {
    label: locale === "id" ? "Rekomendasi" : "Recommendation",
    value: "order_weight-asc",
  },
  {
    label: locale === "id" ? "Terbaru" : "Newest",
    value: "created_at-desc",
  },
  {
    label: locale === "id" ? "Terlama" : "Oldest",
    value: "created_at-asc",
  },
  {
    label: locale === "id" ? "Harga Terendah" : "Lowest Price",
    value: "sell_price-asc",
  },
  {
    label: locale === "id" ? "Harga Tertinggi" : "Highest Price",
    value: "sell_price-desc",
  },
  {
    label: locale === "id" ? "Alfabetis" : "Alphabetical",
    value: "title-asc",
  },
]
